import React, { useEffect } from 'react';
import Form from '@rjsf/core';
import { useAppDispatch } from '@/redux/hooks';
import { addSchemaFormRef, removeSchemaFormRef } from '@/redux/slices/orderPlacementSlice';

// In some components we don't want to add schema form ref to the store, that's why we have a disabled prop.
type Props = { disabled: true } | { disabled: false; formRef: React.RefObject<Form>; key: string };

const useRegisterOrderFormRef = (props: Props) => {
  const dispatch = useAppDispatch();
  const formRefCurrent = props.disabled ? undefined : props.formRef.current;

  useEffect(() => {
    if (props.disabled) return;
    const { formRef, key } = props;
    if (formRef.current) {
      dispatch(addSchemaFormRef({ key, ref: formRef }));
    }
  }, [formRefCurrent]);

  useEffect(() => {
    return () => {
      if (props.disabled) return;
      dispatch(removeSchemaFormRef(props.key));
    };
  }, []);
};

export default useRegisterOrderFormRef;
